import React from 'react';
import { threatApi } from '../services/api';
import { RegisterItemDetail } from './RegisterItemDetail';

export const ThreatDetail: React.FC = () => {
  return (
    <RegisterItemDetail
      kind="threat"
      idParam="id"
      title="Threat"
      iconClass="ri-skull-2-line"
      api={threatApi}
    />
  );
};
